import React from 'react';
import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import VideoPlayer from '@/pages/Courses/ClassDetail/Partials/VideoPlayer';

type AmaDescriptionData = {
    bunny_url: string | null;
    description: string | null;
};

interface Props {
    amaDescription: AmaDescriptionData;
}

const AmaDescriptionBanner: React.FC<Props> = ({ amaDescription }) => {
    const { t } = useTranslation();
    const hasVideo = Boolean(amaDescription.bunny_url);
    const hasDescription = Boolean(amaDescription.description);

    if (!hasVideo && !hasDescription) {
        return null;
    }

    return (
        <div className="mb-6 flex flex-col gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4 sm:flex-row sm:items-start">
            {hasVideo && (
                <div className="w-full flex-shrink-0 overflow-hidden rounded-md sm:w-52">
                    <VideoPlayer videoUrl={amaDescription.bunny_url ?? undefined} />
                </div>
            )}
            {hasDescription && (
                <div className="flex min-w-0 flex-1 gap-2">
                    <Info size={15} className="mt-0.5 flex-shrink-0 text-gray-400" />
                    <div>
                        <p className="mb-1 text-sm font-semibold text-gray-700">{t('course.whatIsAma', '¿Qué es una AMA?')}</p>
                        <p className="text-sm leading-relaxed text-gray-600">{amaDescription.description}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AmaDescriptionBanner;
